import {fetchSaga} from "@atg-shared/fetch-redux";
import {runLazySaga} from "@atg-shared/lazy-store";
import {analyticsSaga} from "@atg-sport-shared/sportsbook-data-access-analytics";
import {betslipSaga} from "@atg-sport-shared/sportsbook-data-access-betslip";
import {
    kambiClientSaga,
    kambiWapiSaga,
} from "@atg-sport-shared/sportsbook-data-access-kambi";
import {kambiAuthSaga} from "@atg-sport-shared/sportsbook-data-access-kambi-auth";
import {kambiLoginSaga} from "@atg-sport-shared/sportsbook-data-access-kambi-login";
import {offeringSaga} from "@atg-sport-shared/sportsbook-data-access-offering";
import {wapiSaga} from "@atg-sport-shared/sportsbook-data-access-wapi";

import type {LazyStore} from "@atg-shared/lazy-store";
import type {Action} from "redux";

export default function rootSaga(store: LazyStore<unknown, Action>) {
    runLazySaga(store, fetchSaga);
    runLazySaga(store, offeringSaga);
    runLazySaga(store, kambiLoginSaga);
    runLazySaga(store, kambiAuthSaga);
    runLazySaga(store, offeringSaga);
    runLazySaga(store, wapiSaga);
    runLazySaga(store, betslipSaga);
    runLazySaga(store, analyticsSaga);
    runLazySaga(store, kambiClientSaga);
    runLazySaga(store, kambiWapiSaga);
}
